// Drops the page header registration (see usePageHeader) once a navigation has finished without a page
// of the new route replacing it, so a page that registers nothing gets the plain header. Doing it here,
// and not when the old page unmounts, avoids a frame or two of empty header between the two pages.
// The transition end, not page:finish: page:finish fires before the new page's onMounted has registered.
//
// It also records every page under its history entry for the back arrow (useUpNavigation): a page that registers a
// header when it does, Home and the event list (which register none) once the navigation has finished.
export default defineNuxtPlugin((nuxtApp) => {
  const pageHeader = usePageHeader();
  const router = useRouter();
  const {recordPage} = useUpNavigation();

  watch(pageHeader, (header) => {
    const route = router.currentRoute.value;
    if(header && header.path === route.path) {
      recordPage({path: route.fullPath, title: header.title, list: header.list ?? !header.showBack});
    }
  });

  nuxtApp.hook('page:transition:finish', () => {
    const route = router.currentRoute.value;
    if(pageHeader.value && pageHeader.value.path !== route.path) {
      pageHeader.value = null;
    }
    const listTitle = UNREGISTERED_LIST_TITLES[String(route.name)];
    if(!pageHeader.value && listTitle) {
      recordPage({path: route.fullPath, title: listTitle, list: true});
    }
  });
});
